import { schema,  normalize as _normailze } from 'normalizr';

export const normalize = (data, schema) => {
  const normalizedData = _normailze(data, schema);
  const entityName = schema._key ? schema._key : schema.schema._key;

  return {
    byId: normalizedData.entities[entityName] || {},
    ids: normalizedData.result
  };
}

const createEntity = (collectionName, idName) => new schema.Entity(collectionName, {}, { idAttribute: idName ? idName : 'id' });

const createEntityArray = entity => new schema.Array(entity);

export const user = createEntity("users", "email");
export const arrayOfUsers = createEntityArray(user);

export const persona = createEntity("personas");
export const arrayOfPersonas = createEntityArray(persona);

export const station = createEntity("stations");
export const arrayOfStations = createEntityArray(station);

export const stationConfig = createEntity("stationConfigs");
export const arrayOfStationConfigs = createEntityArray(stationConfig);

export const healthData = createEntity("healthData", "stationId");
export const arrayOfHealthData = createEntityArray(healthData);

export const downloadRequest = createEntity("downloadRequests");
export const arrayOfDownloadRequest = createEntityArray(downloadRequest);

export const errorReport = createEntity("errorReports");
export const arrayOfErrorReport = createEntityArray(errorReport);